import React from "react";

export default function VirtualGrid({ items = [], loading, onItemClick }) {
  if (loading) return <div className="p-4">Завантаження…</div>;
  if (!items.length) return <div className="p-4">Порожньо</div>;

  return (
    <div className="p-3 space-y-3 w-full max-w-full">
      {items.map((it) => {
        const key = it.id || it._id;
        const img = it.photo_url || (Array.isArray(it.images) && it.images[0]) || null;

        return (
          <div
            key={key}
            onClick={() => onItemClick?.(it)}
            className="flex bg-base-100 rounded-xl border overflow-hidden cursor-pointer hover:shadow-md transition-all"
            style={{ width: "100%", minHeight: 140 }}
          >
            {/* Фото слева */}
            <div
              className="flex-shrink-0 bg-gray-50"
              style={{ width: 180, height: 140, display: "flex", alignItems: "center", justifyContent: "center", overflow: "hidden" }}
            >
              {img ? (
                <img src={img} alt="" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
              ) : (
                <div style={{ color: "#999", fontSize: 12 }}>Без фото</div>
              )}
            </div>

            {/* Текст справа */}
            <div className="flex-1 p-4 flex flex-col justify-center">
              <div className="font-semibold text-base leading-tight">
                {it.name || "(без назви)"}
              </div>

              <div className="text-xs text-gray-500 mt-2 space-y-1">
                {it.code && <div><b>Код:</b> {it.code}</div>}
                {(it.group || it.section_name) && (
                  <div><b>Група:</b> {it.group || it.section_name}</div>
                )}
                {it.category_name && <div><b>Категорія:</b> {it.category_name}</div>}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
